import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-ba0b5c8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modern-form-container" };
const _hoisted_2 = { class: "form-card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"header-icon\" data-v-ba0b5c8a><svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-ba0b5c8a><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-ba0b5c8a></path><polyline points=\"14,2 14,8 20,8\" data-v-ba0b5c8a></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-ba0b5c8a></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-ba0b5c8a></line><polyline points=\"10,9 9,9 8,9\" data-v-ba0b5c8a></polyline></svg></div>", 1);
const _hoisted_5 = { class: "form-title" };
const _hoisted_6 = { class: "form-subtitle" };
const _hoisted_7 = { class: "card-body" };
const _hoisted_8 = { class: "action-section" };
const _hoisted_9 = { class: "action-highlight" };
const _hoisted_10 = /*#__PURE__*/ _createStaticVNode("<div class=\"action-icon\" data-v-ba0b5c8a><svg width=\"24\" height=\"24\" viewBox=\"0 0 60 60\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-ba0b5c8a><g transform=\"translate(-27.164465,-22.917748)\" data-v-ba0b5c8a><path d=\"m 0,0 h -2.667 c -2.37,0 -4.292,-1.922 -4.292,-4.292 v -40.531 c 9.254,-5.642 15.466,-15.801 15.466,-27.409 0,-11.609 -6.212,-21.766 -15.466,-27.408 v -40.531 c 0,-2.37 1.922,-4.292 4.292,-4.292 h 34.965 c 2.37,0 4.292,1.922 4.292,4.292 V -36.59 C 36.59,-16.382 20.208,0 0,0\" fill=\"currentColor\" transform=\"matrix(0.35277776,0,0,-0.35277776,65.722366,27.436081)\" data-v-ba0b5c8a></path><path d=\"M 0,0 C 0,11.606 6.209,21.762 15.459,27.405 V 67.94 c 0,2.371 -1.922,4.292 -4.292,4.292 h -34.959 c -2.37,0 -4.292,-1.921 -4.292,-4.292 v -96.626 c 0,-22.419 16.942,-40.882 38.722,-43.281 2.561,-0.282 4.821,1.715 4.821,4.292 v 40.272 C 6.209,-21.761 0,-11.605 0,0\" fill=\"currentColor\" transform=\"matrix(0.35277776,0,0,-0.35277776,46.067715,52.959801)\" data-v-ba0b5c8a></path><path d=\"m 0,0 c -3.539,5.468 -9.662,9.112 -16.645,9.112 -7.015,0 -13.158,-3.682 -16.689,-9.193 -1.976,-3.086 -3.159,-6.728 -3.159,-10.657 0,-3.927 1.183,-7.57 3.159,-10.655 3.531,-5.51 9.674,-9.193 16.689,-9.193 6.983,0 13.106,3.645 16.645,9.112 2.007,3.101 3.203,6.776 3.203,10.736 C 3.203,-6.776 2.007,-3.101 0,0\" fill=\"currentColor\" transform=\"matrix(0.35277776,0,0,-0.35277776,63.267456,49.129973)\" data-v-ba0b5c8a></path></g></svg></div>", 1);
const _hoisted_11 = { class: "action-info" };
const _hoisted_12 = { class: "action-buttons" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M15 18L9 12L15 6" })
], -1));
const _hoisted_15 = ["disabled"];
const _hoisted_16 = {
    key: 0,
    class: "spinner"
};
const _hoisted_17 = { class: "info-section" };
const _hoisted_18 = { class: "section-header" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "section-icon user-icon" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "12",
            cy: "7",
            r: "4"
        })
    ])
], -1));
const _hoisted_20 = { class: "section-title" };
const _hoisted_21 = { class: "info-grid" };
const _hoisted_22 = { class: "info-item" };
const _hoisted_23 = { class: "info-label" };
const _hoisted_24 = { class: "info-value" };
const _hoisted_25 = { class: "info-item" };
const _hoisted_26 = { class: "info-label" };
const _hoisted_27 = { class: "info-value" };
const _hoisted_28 = { class: "info-item" };
const _hoisted_29 = { class: "info-label" };
const _hoisted_30 = { class: "info-value" };
const _hoisted_31 = { class: "info-section" };
const _hoisted_32 = { class: "section-header" };
const _hoisted_33 = /*#__PURE__*/ _createStaticVNode("<div class=\"section-icon company-icon\" data-v-ba0b5c8a><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-ba0b5c8a><path d=\"M3 21h18\" data-v-ba0b5c8a></path><path d=\"M5 21V7l8-4v18\" data-v-ba0b5c8a></path><path d=\"M19 21V11l-6-4\" data-v-ba0b5c8a></path><line x1=\"9\" y1=\"9\" x2=\"9\" y2=\"9.01\" data-v-ba0b5c8a></line><line x1=\"9\" y1=\"12\" x2=\"9\" y2=\"12.01\" data-v-ba0b5c8a></line><line x1=\"9\" y1=\"15\" x2=\"9\" y2=\"15.01\" data-v-ba0b5c8a></line><line x1=\"15\" y1=\"13\" x2=\"15\" y2=\"13.01\" data-v-ba0b5c8a></line><line x1=\"15\" y1=\"16\" x2=\"15\" y2=\"16.01\" data-v-ba0b5c8a></line></svg></div>", 1);
const _hoisted_34 = { class: "section-title" };
const _hoisted_35 = { class: "info-grid" };
const _hoisted_36 = { class: "info-item full-width" };
const _hoisted_37 = { class: "info-label" };
const _hoisted_38 = { class: "info-value" };
const _hoisted_39 = { class: "info-item" };
const _hoisted_40 = { class: "info-label" };
const _hoisted_41 = { class: "info-value" };
const _hoisted_42 = { class: "info-item" };
const _hoisted_43 = { class: "info-label" };
const _hoisted_44 = { class: "info-value" };
const _hoisted_45 = { class: "info-item full-width" };
const _hoisted_46 = { class: "info-label" };
const _hoisted_47 = { class: "info-value" };
const _hoisted_48 = {
    key: 0,
    class: "box-number"
};
const _hoisted_49 = { class: "info-item" };
const _hoisted_50 = { class: "info-label" };
const _hoisted_51 = { class: "info-value" };
const _hoisted_52 = { class: "info-item" };
const _hoisted_53 = { class: "info-label" };
const _hoisted_54 = { class: "info-value" };
const _hoisted_55 = { class: "info-item" };
const _hoisted_56 = { class: "info-label" };
const _hoisted_57 = { class: "info-value" };
const _hoisted_58 = { class: "info-item" };
const _hoisted_59 = { class: "info-label" };
const _hoisted_60 = { class: "info-value" };
const _hoisted_61 = { class: "info-item full-width" };
const _hoisted_62 = { class: "info-label" };
const _hoisted_63 = { class: "info-value" };
const _hoisted_64 = {
    key: 0,
    class: "info-item full-width"
};
const _hoisted_65 = { class: "info-label" };
const _hoisted_66 = { class: "info-value referral-code" };
const _hoisted_67 = /*#__PURE__*/ _createStaticVNode("<div class=\"referral-badge\" data-v-ba0b5c8a><svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-ba0b5c8a><path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\" data-v-ba0b5c8a></path><circle cx=\"9\" cy=\"7\" r=\"4\" data-v-ba0b5c8a></circle><path d=\"M22 21v-2a4 4 0 0 0-3-3.87\" data-v-ba0b5c8a></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\" data-v-ba0b5c8a></path></svg></div>", 1);
const _hoisted_68 = { key: 0 };
const _hoisted_69 = { class: "account-creation-overlay fixed inset-0 z-[9999] overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4" };
const _hoisted_70 = { class: "account-creation-modal bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all" };
const _hoisted_71 = { class: "text-center p-8 pb-6" };
const _hoisted_72 = /*#__PURE__*/ _createStaticVNode("<div class=\"account-creation-icon mx-auto mb-6\" data-v-ba0b5c8a><div class=\"icon-circle\" data-v-ba0b5c8a><svg class=\"icon-svg\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-ba0b5c8a><g transform=\"translate(-27.164465,-22.917748)\" data-v-ba0b5c8a><path d=\"m 0,0 h -2.667 c -2.37,0 -4.292,-1.922 -4.292,-4.292 v -40.531 c 9.254,-5.642 15.466,-15.801 15.466,-27.409 0,-11.609 -6.212,-21.766 -15.466,-27.408 v -40.531 c 0,-2.37 1.922,-4.292 4.292,-4.292 h 34.965 c 2.37,0 4.292,1.922 4.292,4.292 V -36.59 C 36.59,-16.382 20.208,0 0,0\" fill=\"currentColor\" transform=\"matrix(0.35277776,0,0,-0.35277776,65.722366,27.436081)\" data-v-ba0b5c8a></path><path d=\"M 0,0 C 0,11.606 6.209,21.762 15.459,27.405 V 67.94 c 0,2.371 -1.922,4.292 -4.292,4.292 h -34.959 c -2.37,0 -4.292,-1.921 -4.292,-4.292 v -96.626 c 0,-22.419 16.942,-40.882 38.722,-43.281 2.561,-0.282 4.821,1.715 4.821,4.292 v 40.272 C 6.209,-21.761 0,-11.605 0,0\" fill=\"currentColor\" transform=\"matrix(0.35277776,0,0,-0.35277776,46.067715,52.959801)\" data-v-ba0b5c8a></path><path d=\"m 0,0 c -3.539,5.468 -9.662,9.112 -16.645,9.112 -7.015,0 -13.158,-3.682 -16.689,-9.193 -1.976,-3.086 -3.159,-6.728 -3.159,-10.657 0,-3.927 1.183,-7.57 3.159,-10.655 3.531,-5.51 9.674,-9.193 16.689,-9.193 6.983,0 13.106,3.645 16.645,9.112 2.007,3.101 3.203,6.776 3.203,10.736 C 3.203,-6.776 2.007,-3.101 0,0\" fill=\"currentColor\" transform=\"matrix(0.35277776,0,0,-0.35277776,63.267456,49.129973)\" data-v-ba0b5c8a></path></g></svg></div></div>", 1);
const _hoisted_73 = { class: "account-creation-title" };
const _hoisted_74 = { class: "account-creation-subtitle" };
const _hoisted_75 = { class: "px-8 pb-6" };
const _hoisted_76 = { class: "account-creation-content" };
const _hoisted_77 = { class: "feature-list" };
const _hoisted_78 = { class: "feature-item" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "feature-icon bg-blue-100 text-blue-600" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M20 6L9 17L4 12",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ])
], -1));
const _hoisted_80 = { class: "feature-item" };
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "feature-icon bg-green-100 text-green-600" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }),
        /*#__PURE__*/ _createElementVNode("polyline", {
            points: "22,6 12,13 2,6",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ])
], -1));
const _hoisted_82 = { class: "feature-item" };
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "feature-icon bg-purple-100 text-purple-600" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "2"
        }),
        /*#__PURE__*/ _createElementVNode("polyline", {
            points: "12,6 12,12 16,14",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ])
], -1));
const _hoisted_84 = { class: "email-notification" };
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "success-icon" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M20 6L9 17L4 12",
            stroke: "currentColor",
            "stroke-width": "3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ])
], -1));
const _hoisted_86 = { class: "email-content" };
const _hoisted_87 = { class: "email-title" };
const _hoisted_88 = { class: "email-text" };
const _hoisted_89 = {
    key: 0,
    class: "px-8 pb-8"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.stepper_summary')), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.summary_form_below_find_summary_user_and_company')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.t('admin-ui.summary_form_ready_to_create_your_account')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                            class: "back-button",
                            disabled: _ctx.companyCreationIsPending,
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('previousClick')))
                        }, [
                            _hoisted_14,
                            _createTextVNode(" " + _toDisplayString(_ctx.t('admin-ui.back')), 1)
                        ], 8, _hoisted_13),
                        _createElementVNode("button", {
                            class: "create-button",
                            disabled: _ctx.disableCreateAccountButton || _ctx.companyCreationIsPending,
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.createAccount()))
                        }, [
                            (_ctx.companyCreationIsPending)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.companyCreationIsPending
                                ? _ctx.t('admin-ui.creating_account')
                                : _ctx.t('admin-ui.create-account')), 1)
                        ], 8, _hoisted_15)
                    ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.t('admin-ui.user')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t('admin-ui.email')), 1),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.objectFormData.usernameEmail), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t('admin-ui.first_name')), 1),
                            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.objectFormData.firstName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t('admin-ui.last_name')), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.objectFormData.lastName), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.t('admin-ui.company')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t('admin-ui.language_system')), 1),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.getLanguageDisplayName(_ctx.objectFormData.userSystemLanguage)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t('admin-ui.vat_number')), 1),
                            _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.objectFormData.vatNumber), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.t('admin-ui.legal_designation')), 1),
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.objectFormData.designationLegal), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t('admin-ui.street')), 1),
                            _createElementVNode("div", _hoisted_47, [
                                _createTextVNode(_toDisplayString(_ctx.objectFormData.street) + " " + _toDisplayString(_ctx.objectFormData.houseNumber) + " ", 1),
                                (_ctx.objectFormData.boxNumber)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Boîte " + _toDisplayString(_ctx.objectFormData.boxNumber), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t('admin-ui.post_code')), 1),
                            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.objectFormData.postCode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t('admin-ui.city')), 1),
                            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.objectFormData.city), 1)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t('admin-ui.phone')), 1),
                            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.objectFormData.phone), 1)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.t('admin-ui.mobile')), 1),
                            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.objectFormData.mobile || _ctx.t('admin-ui.not_provided')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.t('admin-ui.activity')), 1),
                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.objectFormData.activity || _ctx.t('admin-ui.not_provided')), 1)
                        ]),
                        (_ctx.enableReferralSystem === 'true' && _ctx.objectFormData.referralCode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.t('admin-ui.referral_code')), 1),
                                _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.objectFormData.referralCode), 1),
                                    _hoisted_67
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ]),
        (_ctx.finalApiMakingRequest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                            _hoisted_72,
                            _createElementVNode("h3", _hoisted_73, _toDisplayString(_ctx.finalApiTitleToShow), 1),
                            _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.t('admin-ui.account-creation-popup-subtitle')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                        _hoisted_79,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.account-creation-popup-feature-creation')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                        _hoisted_81,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.account-creation-popup-feature-email')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                        _hoisted_83,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.account-creation-popup-feature-timing')), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                    _hoisted_85,
                                    _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("h4", _hoisted_87, _toDisplayString(_ctx.t('admin-ui.request-sent-successfully')), 1),
                                        _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.t('admin-ui.account-creation-email-notification-merged')), 1)
                                    ])
                                ])
                            ])
                        ]),
                        (_ctx.finalApiShowConfirmButton)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                _createElementVNode("button", {
                                    class: "close-button w-full",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.finalApiMakingRequest = false))
                                }, _toDisplayString(_ctx.t('admin-ui.to_close')), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
